export default __webpack_public_path__ + "motorized_shade.png";